import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=aa875da6&scoped=true&"
import script from "./translation.vue?vue&type=script&lang=js&"
export * from "./translation.vue?vue&type=script&lang=js&"
import style0 from "./translation.vue?vue&type=style&index=0&id=aa875da6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa875da6",
  null
  
)

export default component.exports